var reflector_1 = require('./reflector');
/**
 * The {@link Reflector} used internally in Angular to access metadata
 * about symbols.
 */
exports.reflector = new reflector_1.Reflector();
//# sourceMappingURL=reflection.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/ng-metadata/src/core/reflection/reflection.js
 ** module id = 8
 ** module chunks = 0
 **/